import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { AkaHouseContentsProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/AkaHouseContentsProduct";
import React from "react";

export const akaHouseContentsDetailsList = (
  product: AkaHouseContentsProduct,
  types: any,
  lang: string,
): ProductDetail[] => [
  {
    name: "coverage",
    value: types.coverageGroup[product.coverageGroup][lang],
  },
  {
    name: "deductible",
    value: (
      <DeductibleValue
        value={types.deductibleAmount[product.coverageGroup][lang] ?? "??"}
      />
    ),
  },
];
